import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <PageHeader title={t('terms.privacyPolicy.title')} />

      {/* Contenu de la Politique de Confidentialité */}
      <div className="p-4">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="space-y-6 text-gray-700">
            {/* Date de mise à jour */}
            <p className="text-sm text-gray-500 italic">{t('terms.privacyPolicy.lastUpdated')}</p>
            
            {/* Introduction */}
            <p className="text-sm">{t('terms.privacyPolicy.intro')}</p>

            {/* Responsable du traitement */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.dataController.title')}</h3>
              <p className="text-sm">{t('terms.privacyPolicy.dataController.content')}</p>
            </section>

            {/* Données personnelles collectées */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.dataCollected.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.dataCollected.intro')}</p>
              <ul className="list-disc ml-6 space-y-1">
                <li className="text-sm">{t('terms.privacyPolicy.dataCollected.email')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.dataCollected.account')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.dataCollected.technical')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.dataCollected.events')}</li>
              </ul>
              <p className="text-sm mt-2">{t('terms.privacyPolicy.dataCollected.noOtherData')}</p>
            </section>

            {/* Géolocalisation */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.geolocation.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.geolocation.intro')}</p>
              <ul className="list-disc ml-6 space-y-1">
                <li className="text-sm">{t('terms.privacyPolicy.geolocation.explicit')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.geolocation.notPermanent')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.geolocation.noTracking')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.geolocation.rounded')}</li>
              </ul>
            </section>

            {/* Base légale */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.legalBasis.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.legalBasis.intro')}</p>
              <ul className="list-disc ml-6 space-y-1">
                <li className="text-sm">{t('terms.privacyPolicy.legalBasis.consent')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.legalBasis.contract')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.legalBasis.legitimateInterest')}</li>
              </ul>
              <p className="text-sm mt-2">{t('terms.privacyPolicy.legalBasis.noAdditionalConsent')}</p>
            </section>

            {/* Finalités */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.purposes.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.purposes.intro')}</p>
              <ul className="list-disc ml-6 space-y-1">
                <li className="text-sm">{t('terms.privacyPolicy.purposes.authentication')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.purposes.events')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.purposes.technical')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.purposes.security')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.purposes.statistics')}</li>
              </ul>
            </section>

            {/* Hébergement */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.hosting.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.hosting.intro')}</p>
              <ul className="list-disc ml-6 space-y-1">
                <li className="text-sm">{t('terms.privacyPolicy.hosting.azure')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.hosting.supabase')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.hosting.stripe')}</li>
              </ul>
            </section>

            {/* Intelligence artificielle */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.ai.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.ai.intro')}</p>
              <p className="font-medium text-sm mb-1">{t('terms.privacyPolicy.ai.principlesTitle')}</p>
              <ul className="list-disc ml-6 space-y-1 mb-2">
                <li className="text-sm">{t('terms.privacyPolicy.ai.noPersonalData')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.ai.onlyTechnical')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.ai.noDecision')}</li>
              </ul>
              <p className="text-sm mb-1">{t('terms.privacyPolicy.ai.disclaimer')}</p>
              <p className="text-sm">{t('terms.privacyPolicy.ai.responsibility')}</p>
            </section>

            {/* Cookies */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.cookies.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.cookies.intro')}</p>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.cookies.uniqueId')}</p>
              <p className="text-sm">{t('terms.privacyPolicy.cookies.characteristics')}</p>
            </section>

            {/* Sécurité */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.security.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.security.intro')}</p>
              <ul className="list-disc ml-6 space-y-1 mb-2">
                <li className="text-sm">{t('terms.privacyPolicy.security.httpsEncryption')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.security.dataEncryption')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.security.accessControl')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.security.logging')}</li>
              </ul>
              <p className="text-sm">{t('terms.privacyPolicy.security.breach')}</p>
            </section>

            {/* Durée de conservation */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.retention.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.retention.general')}</p>
              <p className="font-medium text-sm mb-1">{t('terms.privacyPolicy.retention.deletionTitle')}</p>
              <ul className="list-disc ml-6 space-y-1">
                <li className="text-sm">{t('terms.privacyPolicy.retention.dataDeleted')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.retention.delay')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.retention.legalObligations')}</li>
              </ul>
            </section>

            {/* Droits des utilisateurs */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.userRights.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.userRights.intro')}</p>
              <ul className="list-disc ml-6 space-y-1 mb-2">
                <li className="text-sm">{t('terms.privacyPolicy.userRights.access')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.userRights.rectification')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.userRights.erasure')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.userRights.opposition')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.userRights.limitation')}</li>
              </ul>
              <p className="text-sm mb-1">{t('terms.privacyPolicy.userRights.contact')}</p>
              <p className="text-sm">{t('terms.privacyPolicy.userRights.authority')}</p>
            </section>

            {/* Communications */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.communications.title')}</h3>
              <p className="text-sm mb-2">{t('terms.privacyPolicy.communications.intro')}</p>
              <ul className="list-disc ml-6 space-y-1 mb-2">
                <li className="text-sm">{t('terms.privacyPolicy.communications.technical')}</li>
                <li className="text-sm">{t('terms.privacyPolicy.communications.marketing')}</li>
              </ul>
              <p className="text-sm">{t('terms.privacyPolicy.communications.unsubscribe')}</p>
            </section>

            {/* Modifications */}
            <section>
              <h3 className="text-h3 mb-2">{t('terms.privacyPolicy.modifications.title')}</h3>
              <p className="text-sm">{t('terms.privacyPolicy.modifications.content')}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
